/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CrmIssueElastic, CompoApiService} from 'compob2b-libs';
import { HttpParams } from '@angular/common/http';
import {map} from 'rxjs/operators';

interface TaskLinks {
  crmIssueId: number;
  links: number[];
}

interface CrmIssueTaskLinks {
  id: number;
  links: CrmIssueElastic[];
}

interface DeleteTaskLink {
  id: number;
  linkId: number;
}

@Injectable({ providedIn: 'root' })
export class TaskLinkService {

  constructor(private readonly apiService: CompoApiService) {
  }

  load(id: number): Observable<CrmIssueElastic[]> {
    const url = '/issue/' + id + '/task-link';

    return this.apiService.get<CrmIssueElastic[]>(url).pipe(
      map(response => response.data)
    );
  }

  search(keyword: string = ''): Observable<CrmIssueElastic[]> {
    const url = '/issue/elasticsearch';

    const params = new HttpParams().set('keyword', keyword.toLocaleLowerCase());

    return this.apiService.getWithParams<CrmIssueElastic[]>(url, params).pipe(
      map(response => response.data)
    );
  }

  searchLast(): Observable<CrmIssueElastic[]> {
    const url = '/issue/elasticsearch/last';
    return this.apiService.get<CrmIssueElastic[]>(url).pipe(
      map(response => response.data)
    );
  }

  store(payload: CrmIssueTaskLinks): Observable<CrmIssueElastic[]> {
    const data: TaskLinks = {
      crmIssueId: payload.id,
      links: payload.links.map(item => item.id)
    };
    const url = '/issue/task-link';
    return this.apiService.post<TaskLinks, string>(url, data).pipe(
      map(_ => payload.links)
    );
  }

  delete(payload: DeleteTaskLink): Observable<number> {
    const url = '/issue/' + payload.id + '/task-link/' + payload.linkId;
    return this.apiService.delete<number>(url).pipe(
      map( _ => payload.linkId)
    );
  }
}
